(() => {
  const init = () => {
    document.querySelectorAll('.ss-article__content').forEach((article) => {
      article.querySelectorAll('a[href^="/#"]').forEach((link) => {
        const hash = link.getAttribute('href').slice(1);
        let targetId;
        try { targetId = decodeURIComponent(hash.slice(1)); } catch { return; }
        const target = document.getElementById(targetId);
        if (target && article.contains(target)) link.setAttribute('href', hash);
      });
    });

    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      if (button.dataset.ssReady) return;
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      button.dataset.ssReady = 'true';
      const setOpen = (open) => {
        button.setAttribute('aria-expanded', String(open));
        menu.classList.toggle('ss-nav--open', open);
        const label = button.querySelector('[data-menu-label]');
        if (label) label.textContent = open ? 'Close menu' : 'Open menu';
        if (!open) menu.querySelectorAll('details[open]').forEach((detail) => { detail.open = false; });
      };
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
      menu.addEventListener('click', (event) => { if (event.target.closest('a')) setOpen(false); });
      document.addEventListener('pointerdown', (event) => {
        if (!button.contains(event.target) && !menu.contains(event.target)) setOpen(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          button.focus();
        }
      });
    });

    document.querySelectorAll('[data-product-section]').forEach((region) => {
      if (region.dataset.ssReady) return;
      region.dataset.ssReady = 'true';
      const form = region.querySelector('[data-product-form]');
      const select = form && form.querySelector('[name="id"]');
      const image = region.querySelector('[data-product-image]');
      const thumbs = [...region.querySelectorAll('[data-product-thumbnail]')];
      const status = region.querySelector('[data-gallery-status]');
      const note = region.querySelector('[data-gallery-note]');
      let currentPhoto = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true'));
      const showPhoto = (index, reveal = false) => {
        if (!image || !thumbs.length) return;
        currentPhoto = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[currentPhoto];
        image.src = thumb.dataset.image;
        if (thumb.dataset.srcset) image.srcset = thumb.dataset.srcset;
        else image.removeAttribute('srcset');
        image.alt = thumb.dataset.alt || '';
        thumbs.forEach((item, i) => item.setAttribute('aria-pressed', String(i === currentPhoto)));
        if (status) status.textContent = `Photo ${currentPhoto + 1} of ${thumbs.length}`;
        if (note && select && select.tagName === 'SELECT') {
          const selected = select.options[select.selectedIndex];
          const title = selected && (selected.dataset.title || selected.textContent.trim());
          note.textContent = `${thumb.dataset.color && thumb.dataset.color !== 'shared' ? `Photo: ${thumb.dataset.color}` : 'Product photo'}${title ? ` · Selected: ${title}` : ''}`;
        }
        if (reveal) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showPhoto(index)));
      const controls = region.querySelector('[data-gallery-controls]');
      if (controls && thumbs.length > 1) {
        controls.hidden = false;
        region.querySelector('[data-gallery-prev]').addEventListener('click', () => showPhoto(currentPhoto - 1, true));
        region.querySelector('[data-gallery-next]').addEventListener('click', () => showPhoto(currentPhoto + 1, true));
        if (status) status.textContent = `Photo ${currentPhoto + 1} of ${thumbs.length}`;
      }
      const stage = region.querySelector('[data-gallery-stage]');
      if (stage && thumbs.length > 1) {
        let start;
        stage.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' && !event.target.closest('button')) start = { x: event.clientX, y: event.clientY };
        });
        stage.addEventListener('pointercancel', () => { start = null; });
        stage.addEventListener('pointerup', (event) => {
          if (!start) return;
          const dx = event.clientX - start.x, dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) > 45 && Math.abs(dy) < 45) showPhoto(currentPhoto + (dx < 0 ? 1 : -1), true);
        });
      }
      const zoom = region.querySelector('[data-gallery-zoom]');
      const dialog = region.querySelector('[data-gallery-dialog]');
      if (zoom && dialog && image && typeof dialog.showModal === 'function') {
        zoom.hidden = false;
        zoom.addEventListener('click', () => {
          const large = dialog.querySelector('[data-gallery-large-image]');
          if (large) { large.src = image.src; large.removeAttribute('srcset'); large.alt = image.alt; }
          dialog.showModal();
        });
        region.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => zoom.focus());
      }

      if (form && select && select.tagName === 'SELECT') {
        const choices = region.querySelector('[data-variant-choices]');
        const updateVariant = (changeURL = true) => {
          const option = select.options[select.selectedIndex];
          if (!option) return;
          const available = option.dataset.available === 'true';
          const title = option.dataset.title || option.textContent.trim();
          region.querySelectorAll('[data-add-button]').forEach((button) => {
            button.disabled = !available || form.dataset.cartPending === 'true';
            button.textContent = available ? 'Add to cart' : 'Sold out';
          });
          region.querySelectorAll('[data-variant-choice]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.variantChoice === option.value)));
          region.querySelectorAll('[data-selected-variant], [data-sticky-variant]').forEach((label) => { label.textContent = title; });
          const quantity = form.querySelector('[name="quantity"]');
          if (quantity) {
            const minimum = Number(option.dataset.minimum || 1), step = Number(option.dataset.increment || 1);
            quantity.min = String(minimum);
            quantity.step = String(step);
            if (option.dataset.maximum) quantity.max = option.dataset.maximum;
            else quantity.removeAttribute('max');
            const input = Number(quantity.value), current = Number.isFinite(input) ? input : minimum;
            let aligned = minimum + Math.max(0, Math.ceil((current - minimum) / step)) * step;
            if (option.dataset.maximum) {
              const lastValid = minimum + Math.floor((Number(option.dataset.maximum) - minimum) / step) * step;
              aligned = Math.min(lastValid, aligned);
            }
            quantity.value = String(aligned);
          }
          region.querySelectorAll('[data-product-price], [data-sticky-price]').forEach((price) => { price.textContent = option.dataset.price; });
          const compare = region.querySelector('[data-product-compare]');
          if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
          const dynamicCheckout = region.querySelector('[data-dynamic-checkout]');
          if (dynamicCheckout) dynamicCheckout.hidden = !available;
          // An explicit native variant pointer or source color: prefix is evidence of association.
          const nativePhoto = thumbs.findIndex((thumb) => option.dataset.imageId && thumb.dataset.imageId === option.dataset.imageId);
          const matchingPhoto = nativePhoto >= 0 ? nativePhoto : thumbs.findIndex((thumb) => thumb.dataset.color === title);
          if (matchingPhoto >= 0) {
            showPhoto(matchingPhoto);
            if (note) note.textContent = `Selected: ${title}`;
          } else if (image && option.dataset.image) {
            image.src = option.dataset.image;
            image.removeAttribute('srcset');
            image.alt = option.dataset.imageAlt || image.alt;
            thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', 'false'));
            if (note) note.textContent = `Selected: ${title}`;
          } else if (note) {
            note.textContent = `Selected: ${title}. Photos are for product reference.`;
          }
          if (changeURL) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url);
          }
        };
        select.addEventListener('change', () => updateVariant());
        if (choices) {
          choices.hidden = false;
          const fallback = region.querySelector('[data-variant-fallback]');
          if (fallback) fallback.hidden = true;
          choices.querySelectorAll('[data-variant-choice]').forEach((button) => button.addEventListener('click', () => { select.value = button.dataset.variantChoice; updateVariant(); }));
        }
        updateVariant(false);
      }
      const sticky = region.querySelector('[data-sticky-buy]');
      const primary = region.querySelector('[data-primary-add]');
      if (sticky && primary && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
          document.body.classList.toggle('ss-has-buy-bar', !sticky.hidden);
        });
        observer.observe(primary);
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  // Keep every money amount, tax label and payment icon in Shopify-rendered HTML.
  if (typeof document.querySelector !== 'function' || typeof window.fetch !== 'function' || typeof DOMParser !== 'function') return;
  let cart;
  const initCart = () => {
    const dialog = document.querySelector('[data-cart-drawer]');
    if (!dialog || typeof dialog.showModal !== 'function' || !dialog.dataset.cartSection) return;
    if (cart && cart.dialog === dialog) return;
    if (cart && cart.dialog.open) cart.dialog.close();
    cart = { dialog, busy: false, stale: false, opener: null };
    const current = cart;
    dialog.addEventListener('close', () => {
      document.body.classList.remove('ss-cart-drawer-open');
      document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      if (current.opener && current.opener.isConnected) current.opener.focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  };
  const message = (current, text, link = false) => {
    const status = current.dialog.querySelector('[data-cart-status]');
    status.textContent = text;
    if (link) {
      const anchor = document.createElement('a');
      anchor.href = current.dialog.dataset.cartUrl;
      anchor.textContent = 'View cart';
      status.append(' ', anchor);
    }
    status.hidden = !text;
  };
  const busy = (current, value) => {
    current.busy = value;
    current.dialog.setAttribute('aria-busy', String(value));
    current.dialog.querySelectorAll('[data-cart-content] button, [data-cart-quantity]').forEach((control) => {
      if (value) {
        control.dataset.cartWasDisabled = String(control.disabled);
        control.disabled = true;
      } else if ('cartWasDisabled' in control.dataset) {
        control.disabled = current.stale || control.dataset.cartWasDisabled === 'true';
        delete control.dataset.cartWasDisabled;
      } else if (current.stale) {
        control.disabled = true;
      }
    });
  };
  const open = (current, opener) => {
    current.opener = opener || current.opener;
    if (!current.dialog.open) current.dialog.showModal();
    document.body.classList.add('ss-cart-drawer-open');
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    current.dialog.querySelector('[data-cart-close]').focus();
  };
  const render = (current, html, focusKey) => {
    if (typeof html !== 'string') return false;
    const page = new DOMParser().parseFromString(html, 'text/html');
    const nextDialog = page.querySelector('[data-cart-drawer]');
    const next = nextDialog && nextDialog.querySelector('[data-cart-content]');
    if (!next || nextDialog.dataset.cartSection !== current.dialog.dataset.cartSection) return false;
    current.stale = false;
    const content = current.dialog.querySelector('[data-cart-content]');
    content.innerHTML = next.innerHTML;
    ['cartCount', 'cartCurrency', 'cartTaxesIncluded'].forEach((key) => { content.dataset[key] = next.dataset[key]; });
    document.querySelectorAll('.ss-cart-count').forEach((count) => { count.textContent = next.dataset.cartCount; });
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => { trigger.setAttribute('aria-label', `View cart: ${next.dataset.cartCount} items`); });
    if (focusKey && current.dialog.open) {
      const input = [...content.querySelectorAll('[data-cart-quantity]')].find((quantity) => quantity.dataset.lineKey === focusKey);
      (input || current.dialog.querySelector('[data-cart-close]')).focus();
    }
    return true;
  };
  const refresh = async (current, focusKey) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', current.dialog.dataset.cartSection);
    try {
      const response = await window.fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (response.ok) {
        const sections = await response.json();
        if (render(current, sections[current.dialog.dataset.cartSection], focusKey)) return;
      }
    } catch { /* The ordinary cart page below provides the same authoritative header HTML. */ }
    const cartURL = new URL(current.dialog.dataset.cartUrl, window.location.href);
    const previewTheme = url.searchParams.get('preview_theme_id');
    if (previewTheme) cartURL.searchParams.set('preview_theme_id', previewTheme);
    try {
      const response = await window.fetch(cartURL, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
      if (response.ok && render(current, await response.text(), focusKey)) return;
    } catch { /* Keep checkout guarded if neither read confirms the cart. */ }
    throw new Error('Could not refresh your cart.');
  };
  const sectionContext = () => `${window.location.pathname}${window.location.search}`;
  const request = async (url, body, json = false) => {
    const headers = { Accept: 'application/json' };
    if (json) headers['Content-Type'] = 'application/json';
    let response, result;
    try {
      response = await window.fetch(url, { method: 'POST', credentials: 'same-origin', headers, body: json ? JSON.stringify(body) : body });
      result = await response.json();
    } catch { throw new Error('We could not confirm your cart update. Please check your cart.'); }
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Your cart could not be updated. Please try again.');
    return result;
  };
  const refreshAfterChange = async (current, result, focusKey) => {
    if (render(current, result.sections && result.sections[current.dialog.dataset.cartSection], focusKey)) return true;
    try { await refresh(current, focusKey); return true; } catch {
      // The cart mutation already succeeded: never repeat an Add request to recover HTML.
      current.stale = true;
      window.location.assign(current.dialog.dataset.cartUrl);
      return false;
    }
  };
  const change = async (current, key, quantity) => {
    if (current.busy) return;
    busy(current, true);
    message(current, '');
    try {
      const result = await request(current.dialog.dataset.cartChangeUrl, { id: key, quantity, sections: [current.dialog.dataset.cartSection], sections_url: sectionContext() }, true);
      if (await refreshAfterChange(current, result, key)) message(current, 'Cart updated.');
    } catch (error) {
      // A stock error or lost response can follow a successful mutation. Read, never replay.
      try { await refresh(current, key); } catch { current.stale = true; }
      message(current, error.message, true);
    } finally { busy(current, false); }
  };
  const changeQuantity = (input) => {
    const quantity = Number(input.value);
    if (!input.value.trim() || !Number.isInteger(quantity) || quantity < 0 || (quantity !== 0 && !input.checkValidity())) {
      input.reportValidity();
      input.value = input.dataset.current;
      return;
    }
    if (quantity !== Number(input.dataset.current)) change(cart, input.dataset.lineKey, quantity);
  };
  const addError = (form, text, current) => {
    let error = form.querySelector('[data-cart-add-error]');
    if (!error) {
      error = document.createElement('div');
      error.className = 'ss-form-errors';
      error.dataset.cartAddError = '';
      error.setAttribute('role', 'alert');
      error.tabIndex = -1;
      form.prepend(error);
    }
    error.textContent = text;
    const link = document.createElement('a');
    link.href = current.dialog.dataset.cartUrl;
    link.textContent = 'View cart';
    error.append(' ', link);
    error.focus();
  };
  initCart();
  document.addEventListener('shopify:section:load', initCart);
  document.addEventListener('click', (event) => {
    if (!cart || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target.closest('[data-cart-trigger], [data-cart-close], [data-cart-remove], [data-cart-quantity-change]');
    if (!target) return;
    const current = cart;
    if (target.matches('[data-cart-trigger]')) {
      // The full cart page keeps its ordinary native form and refresh behavior.
      if (window.location.pathname.replace(/\/$/, '') === new URL(current.dialog.dataset.cartUrl, window.location.href).pathname.replace(/\/$/, '')) return;
      event.preventDefault();
      open(current, target);
      if (current.busy) return;
      busy(current, true);
      message(current, '');
      refresh(current).catch((error) => { current.stale = true; message(current, error.message, true); }).finally(() => busy(current, false));
      return;
    }
    if (!current.dialog.contains(target)) return;
    event.preventDefault();
    if (target.matches('[data-cart-close]')) { current.dialog.close(); return; }
    if (current.busy) return;
    if (current.stale) { window.location.assign(current.dialog.dataset.cartUrl); return; }
    if (target.matches('[data-cart-remove]')) { change(current, target.dataset.lineKey, 0); return; }
    const input = target.closest('[data-cart-line]').querySelector('[data-cart-quantity]');
    const value = Number(input.dataset.current), minimum = Number(input.dataset.minimum || 1), increment = Number(input.dataset.increment || 1);
    let quantity = target.dataset.cartQuantityChange === 'plus' ? value + increment : value - increment;
    if (quantity < minimum) quantity = 0;
    if (input.dataset.maximum && quantity > Number(input.dataset.maximum)) return;
    change(current, input.dataset.lineKey, quantity);
  });
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!cart || !input.matches('[data-cart-quantity]') || !cart.dialog.contains(input)) return;
    changeQuantity(input);
  });
  document.addEventListener('keydown', (event) => {
    if (!cart || event.key !== 'Enter' || !event.target.matches('[data-cart-quantity]') || !cart.dialog.contains(event.target)) return;
    event.preventDefault();
    changeQuantity(event.target);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!cart) return;
    if (form.matches('[data-cart-drawer-form]')) {
      // Checkout uses Shopify's normal POST form, with the checkout submitter intact.
      if (cart.busy || cart.stale) {
        event.preventDefault();
        if (cart.stale && !cart.busy) window.location.assign(cart.dialog.dataset.cartUrl);
      }
      return;
    }
    if (event.defaultPrevented || !form.matches('[data-product-form]') || (event.submitter && event.submitter.name !== 'add')) return;
    event.preventDefault();
    const current = cart;
    if (current.busy) return;
    const body = new FormData(form);
    body.set('sections', current.dialog.dataset.cartSection);
    body.set('sections_url', sectionContext());
    const error = form.querySelector('[data-cart-add-error]');
    if (error) error.remove();
    const region = form.closest('[data-product-section]');
    const buttons = [...(region || form).querySelectorAll('[data-add-button]')];
    form.dataset.cartPending = 'true';
    buttons.forEach((button) => { button.disabled = true; });
    busy(current, true);
    try {
      const result = await request(current.dialog.dataset.cartAddUrl, body);
      if (await refreshAfterChange(current, result)) { message(current, ''); open(current, event.submitter || buttons[0]); }
    } catch (error) {
      try { await refresh(current); } catch { current.stale = true; }
      addError(form, error.message, current);
    }
    finally {
      delete form.dataset.cartPending;
      const select = form.querySelector('[name="id"]');
      const option = select && select.tagName === 'SELECT' && select.options[select.selectedIndex];
      buttons.forEach((button) => { button.disabled = option ? option.dataset.available !== 'true' : false; });
      busy(current, false);
    }
  });
})();
